<div class="content p-24">

    <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

            <div class="h2 mb-24">{{'Add new service to card'|translate}} {{card.cardNumber}} {{'of'|translate}} {{user.firstName}} {{user.lastName}}</div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Credits'|translate}}</mat-label>
                    <input matInput formControlName="balance" required>
                    <mat-icon matSuffix class="secondary-text">credit_card</mat-icon>
                    <mat-error>{{'Credits quantity is required!'|translate}}</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Service'|translate}}</mat-label>
                    <mat-select formControlName="service" (ngModelChange)="setService(form.get('service').value)">
                        <mat-option [value]="null">
                            {{'For all services'|translate}}
                        </mat-option>
                        <mat-option [value]="service" *ngFor="let service of services">
                            {{service.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Expiration date'|translate}}</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="expirationDate" (dateChange)="onDateChange($event)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <button mat-raised-button type="submit" color="accent">
                        {{'Save'|translate}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
